export const commonMainBtnClasses = "!transition-all duration-250 hover:brightness-110 text-white text-base font-semibold p-3 sm:p-5 sm:text-lg w-fit";